import { toast } from "sonner";
import { Share2 } from "lucide-react";

// Reusable share button: native Web Share API → clipboard fallback → error toast.
export function ShareButton({ title, text, url, label = "Share", testId, className = "" }) {
  const shareUrl = url || window.location.href;

  const doShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url: shareUrl });
        return;
      }
      await navigator.clipboard.writeText(`${text}\n${shareUrl}`);
      toast.success("Copied — share it with someone.");
    } catch (err) {
      if (err && err.name === "AbortError") return; // user closed the share sheet
      try {
        await navigator.clipboard.writeText(`${text}\n${shareUrl}`);
        toast.success("Copied — share it with someone.");
      } catch {
        toast.error("Couldn't share automatically — copy the page link to share.");
      }
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={doShare}
      className={`inline-flex items-center gap-2 rounded-full border border-white/15 text-[#A8A29E] px-5 py-2 text-sm hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors duration-300 ${className}`}
    >
      <Share2 size={15} /> {label}
    </button>
  );
}
